<kfm-card [cardIcon]="icon()" [cardTitle]="cardTitle()">
  <div class="flex flex-col w-full h-full gap-2">
    @if (img()) {
      <div class="w-full h-full p-2 border">
        <img
          [src]="img()"
          alt="Signature"
          class="w-full h-full object-contain"
        />
      </div>
    }
    <div class="flex flex-row gap-2 justify-end">
      @if (img() && isEditable()) {
        <button
          hsIconButton
          [hsTooltip]="tooltipDelete"
          (click)="onDeleteClicked()"
          hsButtonColor="danger"
        >
          <hs-icon [width]="24" [height]="24" [innerHTML]="iconDelete">
          </hs-icon>
        </button>
      }

      @if (isEditable()) {
        <button
          hsButton
          hsButtonSize="sm"
          hsButtonVariant="filled"
          [hsTooltip]="tooltipSign"
          (click)="onSignClicked()"
        >
          Unterschreiben
        </button>
      }
    </div>
  </div>
</kfm-card>
